import { Row, Col, Container, Card, Form, Button, Table, Badge, Spinner, Dropdown, Modal } from "react-bootstrap";
import Layout from "../components/Layout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Paginator from "../components/table/Paginator";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { getAdminActivities } from "../redux/slices/account.service";
import dateFormatter from "../utils/dateFormatter";
import RecordFilter from "../components/RecordFilter";

import {
    Chart as ChartJS,
    ArcElement,
    Title,
    Legend
  } from 'chart.js';
import { Pie } from "react-chartjs-2";

ChartJS.register(ArcElement, Title, Legend);

const Audit = () => {


    const dispatch = useDispatch()
    const isLoaded = useRef(false)

    const [results, setResults] = useState([])
    const [analytics, setAnalytics] = useState({})
    const [tab, setTab] = useState('history_log')
    const [paginationData, setpaginationData] = useState({next: '', prev: ''})
    const [loading, setLoading] = useState(false)
    const [payload, setPayload] = useState({
        page: 1,
        from_date: '',
        to_date: '',
        status: '',
        download: '',
        filter_by: '',
        sort_by: '',
        filter: '',
        gateway: '',
    })

    useEffect(() => {
        loadAudits()
    }, [payload.page])

    // ------- Chart configuration ------------ //

    const DATA_COUNT = 5;
    // const NUMBER_CFG = {count: DATA_COUNT, min: 0, max: 100};

    const data = {
        labels: ['Lagos', 'Abuja', 'Akwa-Ibon', 'Jos', 'Benue'],
        datasets: [
            {
            label: 'Dataset 1',
            data: [10, 20, 30, 40, 50],
            backgroundColor: [
                'red',
                'blue',
                'orange',
                'lightgreen',
                'skyblue',
             ]
            }
        ]
    };

    const chartConfig = {
        type: 'pie',
        data: data,
        options: {
            responsive: true,
            plugins: {
                legend: {
                    position: 'top',
                },
                title: {
                    display: true,
                    text: 'Audit Trail'
                }
            }
        },
    };

    // ------- Chart configuration ------------ //

    const loadAudits = () =>  {
        setLoading(true)
        dispatch(getAdminActivities())
        .then((response) => {
            if(response.payload.results) {
                setResults(response.payload.results)
            }
            if(response.payload?.analytics) {
                setAnalytics(response.payload.analytics)
            }

            if(response.payload?.next || response.payload?.previous) {
                const data = {
                    next: response.payload?.next,
                    prev: response.payload?.previous,
                }
                setpaginationData(data)
            }
        })
        .finally(() => setLoading(false))
    }

    const handleSearch = () => {
        loadAudits()
    }

    const handleInput = (event) => {
        const {name, value} = event.target
        setPayload((prevState)=> ({...prevState,[name]:value}))
    }

    const handlePagination = (data) => {
        setPayload({...payload, page: data})
    }
 
    return (
        <Layout title="Audit Trails">
            <Container className="mt-4 px-4 mb-4">
                {
                    loading ? (
                        <div className="page-loader">
                            <Spinner size="lg" variant="primary"/>
                        </div>
                    ) : null
                }
                <Row className="mb-3">
                    <Col md={12} className="mb-3 d-flex gap-2 wrap table-responsive">
                        <Button 
                            type="button" 
                            variant="light" 
                            className="tab-buttons"
                            active={tab === 'history_log' ? true : false}
                            onClick={ () => setTab('history_log')}
                        >
                            History Log
                        </Button>
                        <Button 
                            type="button" 
                            variant="light" 
                            className="tab-buttons"
                            active={tab === 'all' ? true : false}
                            onClick={ () => setTab('all')}
                        >
                            Business Activities
                        </Button>
                        <Button 
                            type="button" 
                            variant="light" 
                            className="tab-buttons"
                            active={tab === 'location_stats' ? true : false}
                            onClick={ () => setTab('location_stats')}
                        >
                            Location Statistics
                        </Button>
                    </Col>
                </Row>

                <div className="mt-4">
                    <div className="mb-3 mt-3 analytic-row">
                        <div className="card border-0 shadow-sm bg--primary">
                            <div className="d-flex align-items-center gap-2 px-2 py-4">
                                <div className="icon ">
                                </div>
                                <div>
                                    <h3 className="m-0 text-primary font-bold">{analytics?.total_transactions || '0'}</h3>
                                    <p className="text-muted text-sm m-0">All Businesses</p>
                                </div>
                            </div>
                        </div>
                        <div className="card border-0 shadow-sm">
                            <div className="d-flex align-items-center gap-2 px-2 py-4">
                                <div className="icon bg-light">
                                </div>
                                <div>
                                    <h3 className="m-0 text-success font-bold">{analytics?.total_successful_transactions || '0'}</h3>
                                    <p className="text-muted text-sm m-0">Total Businesses Online</p>
                                </div>
                            </div>
                        </div>
                        <div className="card border-0 shadow-sm">
                            <div className="d-flex align-items-center gap-2 px-2 py-4">
                                <div className="icon">
                                </div>
                                <div>
                                    <h3 className="m-0 text-warning font-bold">{analytics?.total_failed_transactions || '0'}</h3>
                                    <p className="text-muted text-sm m-0">Last Seen 24hours ago</p>
                                </div>
                            </div>
                        </div>
                        <div className="card border-0 shadow-sm">
                            <div className="d-flex align-items-center gap-2 px-2 py-4">
                                <div className="icon">
                                </div>
                                <div>
                                    <h3 className="m-0 text-secondary font-bold">{analytics?.total_pending_transactions || '0'}</h3>
                                    <p className="text-muted text-sm m-0">Last 1month +</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <RecordFilter
                        handleInput={handleInput}
                        handleSearchSubmit={handleSearch}
                    />

                    <Card className="border-0 shadow-sm">
                        <Card.Body className="table-responsive">
                            <Table size="sm" className="table-color table-stripedd">
                                {
                                    tab === 'location_stats' ? 
                                        <>
                                            <div className="row justify-content-center">
                                                <div className="col-md-6 col-sm-12">
                                                    <Pie options={chartConfig} data={data} />
                                                </div>
                                            </div>
                                        </>
                                    :
                                    tab === 'history_log' ? 
                                    <>
                                        <thead>
                                            <tr>
                                                <th>SN</th>
                                                <th>Action</th>
                                                <th>Performed By</th>
                                                <th>Details</th>
                                                <th>Date</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                results?.length ? (
                                                    results?.map((item, index) => (
                                                        <tr key={item.id}>
                                                            <td>{index+1}.</td>
                                                            <td>{item.action.split('_').join(" ")}</td>
                                                            <td> {item.performed_by}  </td>
                                                            <td>{item.details}</td>
                                                            <td>{dateFormatter(item.timestamp)}</td>
                                                        </tr>
                                                    ))
                                                )
                                                : 
                                                (
                                                    <tr>
                                                        <td colSpan={4} className="text-center text-muted">No data found</td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>                                           
                                    </>
                                    :
                                    <>
                                        <thead>
                                            <tr>
                                                <th>Wallx ID</th>
                                                <th>Name</th>
                                                <th>Location</th>
                                                <th>Last Seen</th>
                                                <th>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                results?.length ? (
                                                    results?.map((item, index) => (
                                                        <tr key={index+tab}>
                                                            <td>{item.id}</td>
                                                            <td>
                                                                <div className="m-0 d-flex gap-2 align-items-center">
                                                                    <small className={item.status === 'success' ? 'drews-badge drews-badge-success-circle' : 'drews-badge drews-badge-error-circle'}>
                                                                        <i className="lni lni-arrow-top-right"></i>
                                                                    </small>
                                                                    <strong>
                                                                        <p className="m-0">{item.business_name} </p>  
                                                                    </strong>
                                                                </div>
                                                            </td>
                                                            <td> {item.location}  </td>
                                                            <td>{item.last_seen}</td>
                                                            <td>
                                                                <Dropdown>
                                                                    <Dropdown.Toggle variant="light" className="border-0 bg-transparent" size="sm" id="dropdown-basic">
                                                                        <FontAwesomeIcon icon="ellipsis-vertical" style={{fontSize: "20px"}} className="text-muted"/>
                                                                    </Dropdown.Toggle>
        
                                                                    <Dropdown.Menu className="border-0 shadow px-3 py-4">
                                                                        <Dropdown.Item 
                                                                            eventKey={1} 
                                                                            className="text-primary d-flex align-items-center gap-1" 
                                                                            // onClick={() => selectTransaction(item.reference)}
                                                                        >
                                                                        <i className="lni lni-eye" style={{fontSize: "20px"}}></i>  View Details
                                                                        </Dropdown.Item>
                                                                        <Dropdown.Divider />
                                                                        <Dropdown.Item 
                                                                            eventKey={2} 
                                                                            className="text-success d-flex align-items-center gap-1"
                                                                            // onClick={ () => selectTransaction(item.reference) }
                                                                        >
                                                                            <i className="lni lni-question-circle"></i> Approve Business
                                                                        </Dropdown.Item>
                                                                    </Dropdown.Menu>
                                                                </Dropdown>
                                                            </td>
                                                        </tr>
                                                    ))
                                                )
                                                : 
                                                (
                                                    <tr>
                                                        <td colSpan={5} className="text-center text-muted">No data found</td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>                                           
                                    </>
                                }
                            </Table>
                        </Card.Body>
                    </Card>
                    {
                        results?.length ? (
                            <div className="table-responsive mt-2">
                                <Paginator
                                    next={paginationData.next} 
                                    prev={paginationData.prev}
                                    setCurrentPage={ handlePagination }
                                />
                            </div>
                        ) : null
                    }
                </div>
            </Container>
        </Layout>
    );
}

export default Audit;